module.exports = "//static.hsappstatic.net/ecosystem-marketplace-core/static-1.4151/img/callout-wave.svg"